module.exports = __webpack_public_path__ + "img/alpha6.91e48b67.png";